<template>
  <vue-modal
    :delay="100"
    name="paletteModal"
    width="70%"
    height="auto"
    :pivotY="0.3"
    @before-open="beforeOpen"
    @closed="closeModal"
  >
  <section class="swatches-palette-modal">
    <div class="swatches-palette-modal-content">
      <div class="swatches-palette-modal-content-carousel featuretab">
        <carousel
          :per-page="1"
          :paginationEnabled="false"
          :navigationEnabled="navigationEnabled"
          navigationPrevLabel="<span class='icon-arrow-left-indicator-open'></span>"
          navigationNextLabel="<span class='icon-arrow-right-indicator-open'></span>">

          <slide v-for="(item, index) in slideData" :key="index" v-html="item.innerHTML">
          </slide>
        </carousel>
      </div>
      <div v-html="modalData" v-show="false"></div>
    </div>
    <div slot="top-right">
      <button type="button" class="close-button" title="Close" @click="exit">
        <span class="icon-close"></span>
      </button>
    </div>
  </section>
  </vue-modal>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "paletteModal",
  data() {
    return {
      modalData: "",
      slideData: [],
      navigationEnabled: true
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    beforeOpen (event) {
      if (event.params.contentUrl) {
        this.$store.dispatch("swatches/GET_AEM_MODAL_CONTENT", event.params.contentUrl).then((response)=>{
          this.modalData = response;
          this.processContentModal(response);
        });
      }
    },
    processContentModal(domEls) {
      const parser = new DOMParser();
      const els = parser.parseFromString(domEls, 'text/html');
      this.slideData = els.getElementsByClassName('row');
      this.navigationEnabled = this.slideData.length === 1 ? false : true;
    },
    closeModal() {
      this.modalData = "";
      this.slideData = [];
    },
    exit() {
      this.$modal.hide('paletteModal');
    }
  }
}
</script>
